import { render, staticRenderFns } from "./Frequent.vue?vue&type=template&id=50ccbd66"
import script from "./Frequent.vue?vue&type=script&lang=js"
export * from "./Frequent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports